(function() {
  if (!window.location.pathname.includes('inspiracao-bellagoma')) return;

  function init() {
    const grid = document.querySelector('div.js-grid');
    if (!grid) return;

    const items = Array.from(grid.children).filter(function(el) {
      return el.tagName !== 'TEMPLATE' && el.tagName !== 'SCRIPT';
    });

    const initialShow = 12;
    if (items.length <= initialShow) return;

    items.forEach(function(item, i) {
      if (i >= initialShow) item.style.display = 'none';
    });

    const wrap = document.createElement('div');
    wrap.className = 'bellagoma-load-more-wrap';

    const btn = document.createElement('button');
    btn.className = 'bellagoma-load-more-btn';
    btn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0824/5798/5334/files/bellagoma_trigo_copiar.png?v=1761080035" alt="loading"/><span class="bellagoma-btn-label">Ver mais</span>';
    wrap.appendChild(btn);
    grid.parentNode.insertBefore(wrap, grid.nextSibling);

    let shown = initialShow;

    btn.addEventListener('click', function() {
      btn.classList.add('loading');
      setTimeout(function() {
        items.slice(shown, shown + 12).forEach(function(item) {
          item.style.display = '';
        });
        shown += 12;
        btn.classList.remove('loading');
        if (shown >= items.length) wrap.style.display = 'none';
      }, 900);
    });
  }

  window.addEventListener('load', init);
})();
